import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FiInfo } from 'react-icons/fi';
import TooltipOverlay from '../tooltip/Tooltip';

interface Props {
    iconPath?: string;
    desc?: string;
    btnText?: string;
    navigateTo?: string;
    addClass?: string;
    imgClass?: string;
    disableButton?: boolean;
    tooltipDesc?: string;
    title?: string;
    isHorizontalView?: boolean;
    link?: {
        href: string;
        class: string;
        text: string;
        target?: string;
    };
    func?: (...args: any) => void;
    variant?: string;
    isNoResultsState?: boolean;
}

const EmptyState = ({
    desc,
    btnText,
    iconPath = '/icons/line-graph.png',
    imgClass = '',
    navigateTo,
    addClass,
    disableButton = false,
    tooltipDesc,
    title,
    link,
    func,
    isHorizontalView,
    variant = 'outline-primary',
    isNoResultsState,
}: Props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const resolvedIcon = isNoResultsState ? '/icons/placeholders/not-found.svg' : iconPath;
    const resolvedTitle = isNoResultsState ? t('general.no_results_found') : title;
    const resolvedDesc = desc ?? t('general.emptyList');

    const showButton = !isNoResultsState && (!!navigateTo || !!func);

    return (
        <div
            className={`d-flex align-items-center ${
                isHorizontalView ? 'flex-row align-items-center' : 'flex-column justify-content-center'
            } ${addClass ?? ''}`}
        >
            <img src={resolvedIcon} className={`${!isHorizontalView && 'mt-3'} ${imgClass}`} alt="Line graph icon" />
            {!!resolvedTitle && <h5 className="mt-2">{resolvedTitle}</h5>}

            <span className={`text-muted ${isHorizontalView ? 'ml-2' : 'mb-4 mt-2'}`}>{resolvedDesc}</span>

            {showButton && (
                <div className="d-flex align-items-center">
                    <Button
                        disabled={disableButton}
                        onClick={!!func ? func : () => navigate(navigateTo ?? '/')}
                        variant={variant}
                        size="sm"
                    >
                        {btnText}
                    </Button>
                    {disableButton && (
                        <TooltipOverlay className="ms-1" content={tooltipDesc}>
                            <FiInfo size={14} />
                        </TooltipOverlay>
                    )}
                </div>
            )}
            {!!link && (
                <a href={link?.href} target={link?.target ?? '_self'} className={link?.class}>
                    {link?.text}
                </a>
            )}
        </div>
    );
};

export default EmptyState;
